module.exports = __webpack_public_path__ + "static/media/se_page10.5ad4b758.ogg";